import { type ApolloClient, gql } from '@apollo/client/core';
import type { Query } from '../../../generated/api.graphql';
import * as UserPermission from './UserPermission';

// The `id` is what normalizes this onto the same Me entity as App/User's currentUser read,
// which shares the gqlApiClient cache; without it the two selections overwrite each other.
export const USER_PERMISSIONS_QUERY = gql`
  query currentUserPermissions {
    currentUser {
      id
      permissions {
        key
        level
      }
    }
  }
`;

export const fetchUserPermissions = async (
  client: ApolloClient<Query>,
): Promise<UserPermission.UserPermission[]> => {
  const { data } = await client.query<Query>({
    query: USER_PERMISSIONS_QUERY,
    fetchPolicy: 'network-only',
  });

  if (!data?.currentUser?.permissions) {
    throw new Error('currentUser query returned no permissions');
  }

  return UserPermission.fromGqlCollection(data.currentUser.permissions);
};
